module.exports = __webpack_public_path__ + "b092ed2bff0d98726b8060d3f92f7c71.pdf";